var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7703 12.9077C21.6473 12.1692 21.4626 16.2923 22.3857 18.4462C21.1549 22.7538 21.0932 31.1844 30.6932 30.4459C42.6932 29.5228 34.3855 16.5998 36.2317 16.5998C38.0779 16.5998 40.8471 11.9847 36.2317 9.21543C32.5394 7.00005 30.3857 10.7539 29.7703 12.9077Z",
    fill: "#171453"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9233 45.2153C19.308 41.8307 28.6618 36.9076 39.0003 44.2922C35.308 47.3692 25.5233 51.8616 15.9233 45.2153Z",
    fill: "#5C58E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2314 31.616C16.8464 30.4459 18.6926 18.6929 22.385 17.5228C29.7696 18.2613 31.0004 26.4459 30.6928 30.4459L31.6159 40.5998C32.2312 40.5998 32.1697 41.5228 27.0005 45.2151C21.8312 48.9074 21.7697 43.6767 22.385 40.5998L24.2314 31.616Z",
    fill: "#D47065"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9c8671d0c633dec27967000ca939450e.svg";
export { ForwardRef as ReactComponent };